export default __webpack_public_path__ + "static/media/customer_profile.45d1a4d4.svg";